import { ClipboardDocumentIcon } from "@heroicons/react/24/solid";
import { ReactNode, useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

export default function ClickToCopy({
  text,
  value = null,
  title = "",
  className = "",
  textClassName = "",
  middle,
}: {
  text: string | number | undefined | null;
  value?: string | number | undefined | null;
  title?: string;
  className?: string;
  textClassName?: string;
  middle?: ReactNode;
}) {
  const { t } = useTranslation("common");
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    if (!text && !value) return;

    var toCopy = value ? value : text;

    navigator.clipboard
      .writeText(toCopy?.toString() || "")
      .then(() => setCopied(true))
      .catch((err) => {
        console.error("Failed to copy: ", err);
      });
  };

  // hide bubble after 1s
  useEffect(() => {
    if (!copied) return;
    const t = setTimeout(() => setCopied(false), 1000);
    return () => clearTimeout(t);
  }, [copied]);

  if (!text && !value) return null;

  return (
    <div
      title={title}
      className={`relative flex items-center ${middle ? "gap-x-1" : "justify-between"} ${className}`}
      onClick={(e) => e.stopPropagation()}
    >
      {/*
        Bubble: absolutely positioned,
        animates via the 'animate-fade-up' class
      */}
      {copied && (
        <div className="absolute -top-8 right-0 bg-gray-800 text-white text-xs rounded px-2 py-1 animate-fade-up">
          {t("Copied!")}
        </div>
      )}

      <p className={`mr-1 min-w-0 ${textClassName}`}>{text}</p>
      {middle}
      <ClipboardDocumentIcon
        className={`w-5 h-5 text-gray-600 cursor-pointer hover:scale-110 
          hover:text-primary transition-all duration-200 ${middle ? "ml-auto shrink-0" : ""}`}
        onClick={handleCopy}
      />
    </div>
  );
}
